// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Board_Board($board_id: uuid!, $and: [tasks_tasks_bool_exp!]) {
  active_tasks: tasks_tasks(
    where: {
      board_id: { _eq: $board_id }
      stage: { done: { _eq: false } }
      _and: $and
    }
    order_by: { order: asc }
  ) {
    ...task
  }
  done_tasks: tasks_tasks(
    where: {
      board_id: { _eq: $board_id }
      stage: { done: { _eq: true } }
      _and: $and
    }
    order_by: { created_at: desc }
    limit: 30
  ) {
    ...task
  }
}

fragment task on tasks_tasks {
  id
  created_at
  board_id
  location_id
  stage_id
  title
  description
  due_date
  order
  priority
  comments_aggregate {
    aggregate {
      count
    }
  }
  task_tags {
    id
    tag {
      id
      name
    }
  }
  assignees {
    id
    user_id
    user {
      id
      vaxiom_person {
        _id
        first_name
        last_name
      }
    }
  }
  patients {
    id
    _id
    person {
      id
      _id
      greeting
      first_name
      last_name
    }
  }
}

`